var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "switch_account_inner", style: _vm.Styles }, [
    _vm._v(" " + _vm._s(_vm.value.config.name) + " "),
    _c("i", { staticClass: "el-icon el-icon-sort" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }